import { Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from '../../the-connection/tc_scopes'
import { BillingService } from '../billing/bl_service'
import { DEFAULT_TIERS, PriceTierEditorPresenter } from '../billing/bl_price_tier_editor_presenter'
import type { PriceTierInput } from '../billing/bl_types'
import ConfigurationPresenter from './presenter'
import { BillingConfigScope } from './scopes'

const LOG = Logger.get('BillingConfigPresenter')
const billingService = BillingService.singleton()

export class BillingConfigPresenter extends Presenter<BillingConfigScope, ConfigurationPresenter> {
    public constructor(owner: ConfigurationPresenter) {
        super(owner, owner.scope.billingConfig)
        this.__parent = owner
        this.__tierEditor = new PriceTierEditorPresenter(this, this.scope.tierEditor)
    }

    private readonly __parent: ConfigurationPresenter

    private readonly __tierEditor: PriceTierEditorPresenter

    async initialize() {
        LOG.debug('initialize')
        this.scope.onLoadData = this.action(this.onLoadData)
        this.scope.onSave = this.action(this.handleSave)

        this.onLoadData().catch(LOG.caught)
    }

    async onLoadData() {
        try {
            this.scope.waiting = new WaitingScope()

            const [current, history] = await Promise.all([
                billingService.fetchPriceTable(null),
                billingService.fetchPriceTableHistory(null)
            ])

            this.__tierEditor.setTiers(current?.tiers?.length ? current.tiers.map(toTierInput) : [...DEFAULT_TIERS])
            this.scope.validFrom = current?.validFrom ?? ''
            this.scope.history = history
        } catch (caught) {
            LOG.error('onLoadData', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleSave() {
        const errors = this.__tierEditor.validate()

        if (errors.length > 0) {
            this.__parent.app.notify('warning', 'Corrija as faixas antes de salvar')
            return
        }

        try {
            this.scope.waiting = new WaitingScope()
            await billingService.savePriceTable({ groupId: null, tiers: this.scope.tierEditor.tiers })
            this.__parent.app.notify('success', 'Tabela de preços salva com sucesso')
        } catch (caught) {
            LOG.error('handleSave', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }

        await this.onLoadData()
    }
}

function toTierInput(tier: PriceTierInput): PriceTierInput {
    return { minQty: tier.minQty, maxQty: tier.maxQty ?? null, unitPrice: tier.unitPrice }
}

export default BillingConfigPresenter
